import thecase from './case.pdf';
import thecaseMachinery from './case-machinery.pdf';
import thecaseSupplier from './case-supplier.pdf';
import guidelines from './guidelines.pdf';
import howtoplay from './howtoplay.pdf';

export const getPdf = (scenario, fileName) => {
	switch(fileName) {
		case 'thecase': {
			switch(scenario) {
				case 'default': {
					return {
						name: 'Eris',
						pdf: thecase,
						pages: 22
					}
				}
				case 'supplier': {
					return {
						name: 'Eris',
						pdf: thecaseSupplier,
						pages: 22
					}
				}
				case 'machinery': {
					return {
						name: 'Eris',
						pdf: thecaseMachinery,
						pages: 22
					}
				}
				default: {
					return {
						name: 'Eris',
						pdf: thecase,
						pages: 22
					}
				}
			}
		}
		case 'guidelines': {
			return {
				name: 'Guidelines',
				pdf: guidelines,
				pages: 3
			}
		}
		case 'howtoplay': {
			return {
				name: 'How to play',
				pdf: howtoplay,
				pages: 5
			}
		}
		default: {
			return {
				name: 'Eris',
				pdf: thecase,
				pages: 22
			}
		}
	}
}
